module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.18003/js/img/valuePropModals/TeamNoAccess/ValueProp1.svg"